/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const myAccount = {
  closeAccount: {
    confirmAccountClosure: 'Confirmar el cierre de la cuenta',
    confirmAccountClosureMessage:
      'Are you sure you want to close your account?',
    closeMyAccount: 'CERRAR MI CUENTA',
    accountClosedSuccessfully: 'Cuenta cerrada con éxito',
    accountClosedFailure: 'No se pudo cerrar la cuenta',
  },

  updatePasswordForm: {
    oldPassword: {
      label: 'Contraseña antigua',
      placeholder: 'Contraseña antigua',
    },
    oldPasswordIsRequired: 'Se requiere una contraseña antigua.',
    newPassword: {
      label: 'Nueva contraseña',
      placeholder: 'Nueva contraseña',
    },
    passwordMinRequirements:
      'La contraseña debe tener un mínimo de seis caracteres, con una letra mayúscula, un número y un símbolo',
    confirmPassword: {
      label: 'Confirmar nueva contraseña',
      placeholder: 'Confirmar contraseña',
    },
    bothPasswordMustMatch: 'Ambas contraseñas deben coincidir',
    passwordUpdateSuccess: 'Contraseña actualizada con éxito',
    accessDeniedError: 'Se deniega el acceso',
  },
  updateProfileForm: {
    title: 'Título',
    none: '',
    firstName: {
      label: 'Nombre',
      placeholder: 'Nombre',
    },
    firstNameIsRequired: 'El nombre es obligatorio.',
    lastName: {
      label: 'Apellido',
      placeholder: 'Apellido',
    },
    lastNameIsRequired: 'Se requiere apellido.',
    profileUpdateSuccess: 'Los datos personales se han actualizado correctamente',
    customerId: 'Cliente #',
  },
  consentManagementForm: {
    clearAll: 'Borrar todo',
    selectAll: 'Seleccionar todo',
    message: {
      success: {
        given: 'Consentimiento otorgado con éxito.',
        withdrawn: 'Consentimiento retirado con éxito.',
      },
    },
  },
  myCupóns: {
    noCupónsMessage: 'No tienes cupones disponibles.',
    effectiveTítulo: 'Eficaz:',
    Eficaz: 'EFICAZ',
    PreSession: 'EFICAZ SOON',
    ExpireSoon: 'EXPIRA PRONTO',
    readMore: 'Leer más',
    notification: 'Notificación',
    findProducts: 'Buscar productos',
    status: 'Estado:',
    dialogTítulo: 'Cupón',
    claimCustomerCupón: 'Ha reclamado con éxito este cupón.',
    myCupóns: 'Mis cupones',
    startDateAsc: 'Fecha de inicio (ascendente)',
    startDateDesc: 'Fecha de inicio (descendente)',
    endDateAsc: 'Fecha de finalización (ascendente)',
    endDateDesc: 'Fecha de finalización (descendente)',
    sortBy: 'Ordenar por',
    sortCupóns: 'Ordenar cupones',
    notesPreffix:
      'Puede configurar sus canales preferidos para recibir notificaciones de cupones en el ',
    notesLink: 'Notificación Channels',
    notesSuffix: ' página.',
  },
  notificationPreference: {
    message: 'Selecciona tus canales de notificación preferidos',
    note: 'Nota: ',
    noteMessage:
      'Si desactiva todos los canales, no podrá recibir más notificaciones.',
    EMAIL: 'Correo electrónico:',
    SMS: 'SMS:',
    SITE_MESSAGE: 'Mensaje del sitio',
  },
  myInterests: {
    header: 'Mis Intereses',
    item: 'ARTÍCULO',
    price: 'PRECIO',
    notifications: 'NOTIFICACIONES',
    noInterests: 'Todavía no tiene intereses registrados.',
    inStock: 'En stock',
    lowStock: 'Existencias bajas',
    outOfStock: 'Agotado',
    BACK_IN_STOCK: 'Volver A tronco',
    sortBy: 'Ordenar por',
    sortInterests: 'Ordenar intereses',
    expirationDate: ' - A {{ expirationDate }}',
    productId: 'ID {{ code }}',
    remove: 'Eliminar',
    sorting: {
      byNameAsc: 'Nombre (ascendente)',
      byNameDesc: 'Nombre (descendente)',
    },
    actions: 'ACCIONES',
    caption: 'Mis intereses contentos.',
    itemEliminard: 'Se ha eliminado el elemento seleccionado.',
  },
};
